export const GAME_TIME = 6 * 60;
export const Timer = function (
  totalTime,
  intervalTime,
  intervalCallback,
  timeOutCallback
) {
  if (totalTime < 0)
    throw new Error("Total time cannot be less than 0 seconds");
  if (totalTime < intervalTime)
    throw new Error("Total time cannot be less than interval time");
  if (intervalTime < 0)
    throw new Error("Interval time cannot be less than 0 seconds");
  let timerId,
    interval = intervalTime * 1000,
    remaining = totalTime * 1000;
  let callBack1 = intervalCallback,
    callBack2 = timeOutCallback;
  this.start = function () {
    timerId = setInterval(() => {
      if (remaining <= 1000) {
        this.reset();
        callBack2();
      }
      remaining -= interval;
      callBack1(remaining / 1000);
    }, interval);
  };

  this.pause = function () {
    clearInterval(timerId);
  };
  this.getRemainingTime = function () {
    return Math.floor(remaining / 1000);
  };
  this.resume = function (intervalCallback, timeOutCallback) {
    clearInterval(timerId);
    callBack1 = intervalCallback;
    callBack2 = timeOutCallback;
    this.start();
  };

  this.reset = function () {
    clearInterval(timerId);
    interval = intervalTime;
    remaining = totalTime;
  };
};
